import React from 'react';
import { motion } from 'framer-motion';
import { Users, Banknote, AlertTriangle } from 'lucide-react';
export function Problem() {
  const cards = [{
    icon: <Users className="w-6 h-6" data-id="element-311" />,
    stat: '40%',
    label: 'of your account holders',
    text: "can't or won't use your mobile app. They're queuing in-store every month — eroding CX and shrinking the floor."
  }, {
    icon: <Banknote className="w-6 h-6" data-id="element-312" />,
    stat: 'R 38',
    label: 'per in-store payment',
    text: 'is the average cost of handling cash and card collections at the till. That bleeds straight from your margin.'
  }, {
    icon: <AlertTriangle className="w-6 h-6" data-id="element-313" />,
    stat: '12%',
    label: 'of accounts roll into arrears',
    text: 'because customers forgot, missed the queue, or ran out of data on payday. Most would pay if you made it easier.'
  }];
  return <section className="py-24 bg-ink" data-id="element-314">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-315">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mb-16" data-id="element-316">
          
          <div className="text-xs font-medium uppercase tracking-[0.2em] text-mint mb-4" data-id="element-317">
            The retailer problem
          </div>
          <h2 className="display text-bone mb-6" style={{
          fontSize: 'clamp(2.25rem, 5vw, 4rem)'
        }} data-id="element-318">
            
            Every queue at the till is{' '}
            <span className="display-italic text-mint" data-id="element-319">
              revenue you're losing
            </span>
            .
          </h2>
          <p className="text-lg text-bone-dim leading-relaxed" data-id="element-320">
            Your account holders want to pay. The infrastructure between them
            and your books is what's broken.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-4" data-id="element-321">
          {cards.map((card, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-ink-2 rounded-3xl p-8 border border-white/5 hover:border-mint/30 transition-colors" data-id="element-322">
            
              <div className="w-12 h-12 rounded-2xl bg-mint-soft text-mint flex items-center justify-center mb-6" data-id="element-323">
                {card.icon}
              </div>
              <div className="display text-bone text-5xl mb-1" data-id="element-324">{card.stat}</div>
              <div className="text-xs text-muted uppercase tracking-wider mb-4" data-id="element-325">
                {card.label}
              </div>
              <p className="text-base text-bone-dim leading-relaxed" data-id="element-326">
                {card.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}